$(function () {
    // home review slider
    $('.rslider').owlCarousel({
        loop: true,
        items: 2,
        autoplay: true,
        autoplayTimeout: 3000,
        autoHeight: true,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            1024: {
                items: 2
            }
        }
    });

    // tabs on product pages
    $('body.template-product .tabs .tab-links a').on('click', function () {
        var val = $(this).attr('data-val');
        $('.tab-links a').removeClass('active');
        $(this).addClass('active');

        // tab content
        $('.tab-content .tab').removeClass('active');
        $('.tab-content .tab.' + val).addClass('active');

    });

    // link skincare page in nav w/ target blank
    $('.site-nav a, .site-footer__links a').each(function () {
        if ($(this).attr('href') == 'https://bariatric.stopobesityforlife.com/' || $(this).attr('href') == 'https://stopobesityforlife.brilliantconnections.com/') {
            $(this).attr('target', '_blank');
        }

        if ($(this).attr('href') == 'http://mega-menu-shows.com') {
            $(this).parent().addClass('mega-menu');
            $(this).on('click', function () {
                return false;
            });
        }
    });
});